export default {
  data() {
    return {
      subloading: false,
      loading: false,
    };
  },
  watch: {
    subloading(val) {
      this.$root.$emit("changeSubLoading", val);
    },
    loading(val) {
      this.$root.$emit("updateSubsModalInfoLoading", val);
    },
  },
  created() {
    this.$root.unsubscribe = this.unsubscribe;
    this.$root.subscribe = this.subscribe;
    this.$root.corpRequest = this.corpRequest;
    this.$root.getUserSubscription = this.getUserSubscription;
    this.$root.unsubCancel = this.unsubCancel;
    this.$root.unsubscribeHandler = this.unsubscribeHandler;
  },
  methods: {
    async unsubscribeHandler() {
      if (this.loading) return;

      this.loading = true;

      this.api
        .toggleSubAutoRenew()
        .then((response) => {
          this.$store.dispatch("updateUser", {
            updateFieldOnly: {
              field: "plan",
              value: response.data,
            },
          });
          this.$root.$emit("updateSubsModalInfo", {
            title: this.$t("Subs.unsub.complete.title"),
            text:
              this.$t("Subs.unsub.complete.text1") +
              this.$moment(this.user?.plan?.end_date).format("DD.MM.YYYY") +
              this.$t("Subs.unsub.complete.text2"),
            icon: "fa-circle-check",
            buttons: [
              {
                type: "gray",
                text: this.$t("Subs.backToSite"),
                callback: () => {
                  // this.$store.dispatch("updateSubsModalStatus", false);
                  this.$root.$emit("updateSubsModalInfo", undefined);
                },
              },
              {
                icon: {
                  pos: "left",
                  class: "fa-rotate-right",
                },
                text: this.$t("Subs.unsub.complete.recover"),
                callback: () => {
                  this.$root.unsubCancel(true);
                },
              },
            ],

            component: "AnyText",
          });
        })
        .catch((err) => {
          this.$root.$emit("updateSubsModalStatus", false);
          this.$debug(err, "error", err);
          this.$notify({
            group: "loggedIn",
            type: "error",
            text: err,
          });
        })
        .finally(() => {
          this.$root.getUserSubscription();
          this.loading = false;
        });
    },
    async unsubCancel(toggle) {
      if (this.loading) return;

      this.$root.$emit("updateSubsModalInfo", {
        title: this.$t("Subs.unsub.thx.title"),
        icon: "fa-circle-check",
        text: this.$t("Subs.unsub.cancel")
          .replace(
            "<NAME>",
            this.$t(
              `LK.subscription.plan_${this.user?.plan?.subscription_plan}`
            )
          )
          .replace(
            "<DATE>",
            this.$moment(this.user?.plan?.end_date).format("DD.MM.YYYY")
          ),
        buttons: [
          {
            text: this.$t("Subs.unsub.thx.continue"),
            icon: {
              pos: "right",
              class: "fa-chevron-right",
            },
            callback: () => {
              // this.$store.dispatch("updateSubsModalStatus", false);
              this.$root.$emit("updateSubsModalInfo", undefined);
            },
          },
        ],
        component: "AnyText",
      });

      this.loading = true;

      if (toggle) {
        await this.api.toggleSubAutoRenew();
        await this.$root.getUserSubscription();
      }
      this.loading = false;
    },
    getSubs() {
      this.api.getSubs().then((response) => {
        response?.data?.sort((a, b) => a?.id - b?.id);
        this.$store.dispatch("updateSubsPlans", response?.data);
      });
    },
    unsubscribe() {
      this.$root.$emit("updateSubsModalInfo", {
        title: this.$t("Subs.unsub.modalTitle"),
        icon: "fa-circle-question",
        buttonText: this.$t("Back"),
        component: "Unsubscribe",
      });
    },
    subscribe(plan) {
      if (!!!this.user?.phone || !!!this.user?.email) {
        this.$root.$emit("updateSubsModalInfo", {
          title:
            this.$t("Subs.lets.modalTitle.base") +
            (!!!this.user?.phone ? this.$t("Subs.lets.modalTitle.phone") : "") +
            (!!!this.user?.phone && !!!this.user?.email
              ? this.$t("Subs.lets.modalTitle.and")
              : "") +
            (!!!this.user?.email
              ? this.$t("Subs.lets.modalTitle.email").replace(
                  !!!this.user?.phone && !!!this.user?.email ? "у" : "",
                  ""
                )
              : ""),
          icon: "fa-circle-question",
          component: "LetsSubscribe",
          plan: plan,
          callback: () => {
            this.$root.$emit("updateSubsModalInfo", undefined);
          },
        });
        return;
      }
      this.subloading = plan.id;
      this.api
        .userPurchase({
          data: {
            plan_id: plan.id,
            plan_cost_id: plan?.costs?.[0].id,
            auto_renew: true,
            // promo_code: false,
          },
        })
        .then((response) => {
          if (response.data?.payment_url) {
            window.location.replace(response.data.payment_url);
          } else {
            throw response.data;
          }
        })
        .catch((error) => {
          this.$debug(error, "error", error);
        })
        .finally(() => {
          this.subloading = false;
        });
    },
    corpRequest() {
      this.$axios({
        url:
          "https://dev.demo.thirdopinion.ai/mattermost/" +
          process.env.VUE_APP_MATTERMOST_FEEDBACK_HOOK,
        method: "POST",
        data: {
          text:
            "@andrey_povarenkin запрос на индивидуальный план подписки от " +
            (this.user?.fullName || this.user?.username) +
            ". Свяжитесь с пользователем: почта: " +
            (this.user?.email || "-") +
            " тел: " +
            (this.user?.phone || "-"),
        },
      })
        .then(() => {
          this.$root.$emit("updateSubsModalInfo", {
            title: this.$t("Subs.CorpPlan.requested"),
            text: this.$t("Subs.CorpPlan.requested2"),
            icon: "fa-circle-check",
            buttons: [
              {
                icon: {
                  class: "fa-chevron-left",
                  pos: "left",
                },
                text: this.$t("Back"),
                callback: () => {
                  this.$root.$emit("updateSubsModalInfo", undefined);
                },
              },
            ],
            component: "AnyText",
          });
        })
        .catch(() => {
          this.$notify({
            group: "loggedIn",
            type: "error",
            duration: 3000,
            text: this.$t("Cannot loading reply -- adblock"),
          });
        })
        .finally(() => {
          this.getSubs();
        });
    },
    getUserSubscription() {
      this.api
        .getUserSubscription()
        .then((response) => {
          this.$store.dispatch("updateUser", {
            addExternalData: {
              field: "plan",
              value: response.data,
            },
          });
        })
        .catch(() => {
          this.$store.dispatch("updateUser", {
            addExternalData: {
              field: "plan",
              value: null,
            },
          });
        })
        .finally(this.getSubs);
    },
  },
};
